'use strict';
angular.module('cvsApp').factory('orderSummaryModel',[function() {	
	
	var orderSummary = function(){		

		var apiResponse = {};

		this.getResponse = function(){
			return this;
		}

		this.setResponse = function(data){
			apiResponse = data;
		}
		/**
		 * SP 01/04/2017 - Updated the logic to check for standard API error response.
		 * @returns {*}
		 */
		this.getError = function(){
			if(apiResponse.hasOwnProperty("getOrderSummaryResponse") &&  ((apiResponse.getOrderSummaryResponse.header.statusCode !="0000" && apiResponse.getOrderSummaryResponse.header.statusCode !="7718") || apiResponse.getOrderSummaryResponse.details == undefined || apiResponse.getOrderSummaryResponse.details.orderSummary == undefined || apiResponse.getOrderSummaryResponse.details.orderSummary.shipments == undefined)){
				apiResponse.showError = this.getHeader();
				return apiResponse.showError;
			}
			else if(apiResponse.hasOwnProperty("response") && apiResponse.response.header.statusCode != "0000" && apiResponse.response.header.statusCode != "7718"){
				apiResponse.showError = apiResponse.response.header;
				return apiResponse.showError;
			}
			return "";
		}		

		this.getHeader = function () {
			return apiResponse.getOrderSummaryResponse.header;
		}

		this.getOrderSummary = function(){			
			if(!apiResponse.showError){
				return apiResponse.getOrderSummaryResponse.details.orderSummary;
			}			
		}

		this.getShipmentList = function(){			
			if(!apiResponse.showError){
				var shipMentArray = [];
				if(apiResponse.getOrderSummaryResponse.header.statusCode === '7718'){
					return;
				}
				var data =  apiResponse.getOrderSummaryResponse.details.orderSummary.shipments;
				if(_.isArray(data)){						
					return data;
				}else{						
					shipMentArray.push(data);
					return 	shipMentArray;					
				}
				
			}			
		}

		this.getAddressList = function(){
			if(!apiResponse.showError){
				var shipMentArray = [];
				var addressList = [];
				var data =  apiResponse.getOrderSummaryResponse.details.orderSummary.shipments;
				if(_.isArray(data)){						
					addressList = data;
				}else{						
					addressList.push(data);									
				}
				/**
				 * SP 11/21/2016 - ITPR015400 - Guest Refill
				 * Using Encrypted address id
				 */
                /**
                 * SP 12/02/2016 - ITPR015400 - Guest Refill
                 * Using  address id hash
                 */
				for(var i=0; i< addressList.length; i++){
					var addressObj = {
										addressId:addressList[i].shipmentAddress.addressIdEnc ? addressList[i].shipmentAddress.addressIdEnc : addressList[i].shipmentAddress.addressId,
                        				addressIdHash:addressList[i].shipmentAddress.addressIdHash,
										addressLine1:addressList[i].shipmentAddress.address1,
                        				addressLine1Enc:addressList[i].shipmentAddress.address1Enc,
										addressLine2:addressList[i].shipmentAddress.address2,
                        				addressLine2Enc:addressList[i].shipmentAddress.address2Enc,
										city:addressList[i].shipmentAddress.city,
                        				cityEnc:addressList[i].shipmentAddress.cityEnc,
										state:addressList[i].shipmentAddress.state,
                        				stateEnc:addressList[i].shipmentAddress.stateEnc,
										zipCode:addressList[i].shipmentAddress.zipCode,
                        				zipCodeEnc:addressList[i].shipmentAddress.zipCodeEnc,
										"addressType" : addressList[i].shippedToStoreNumber
										&& addressList[i].shippedToStoreNumber !=="0" ? "shipToStore" :"shipToHome",
										shippedToStoreNumber:addressList[i].shippedToStoreNumber,
										shipmentDate:addressList[i].shippedToStoreNumber,
										shipmentNumber:addressList[i].shippedToStoreNumber
									};
					shipMentArray.push(addressObj);
				}
				return shipMentArray;
			}
		}

		this.getAddressType= function(){
			if(!apiResponse.showError){
				var data =  apiResponse.getOrderSummaryResponse.details.orderSummary.shipments;
				return
			}
		}

	}
	
	return new orderSummary();
}]);